import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Auth service
export const authService = {
  login: async (username, password) => {
    const response = await axios.post(`${API_URL}/api/admin/login`, { username, password });
    if (response.data.access_token) {
      localStorage.setItem('admin_token', response.data.access_token);
      localStorage.setItem('admin_username', response.data.username);
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
  },

  getToken: () => localStorage.getItem('admin_token'),
  getUsername: () => localStorage.getItem('admin_username'),
  isAuthenticated: () => !!localStorage.getItem('admin_token'),

  verifyToken: async () => {
    try {
      const token = authService.getToken();
      if (!token) return false;
      await axios.get(`${API_URL}/api/admin/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return true;
    } catch (error) {
      return false;
    }
  }
};

// Create axios instance with auth
const authAxios = axios.create({ baseURL: API_URL });
authAxios.interceptors.request.use((config) => {
  const token = authService.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Content service
export const contentService = {
  getHomepage: () => authAxios.get('/api/admin/content/homepage'),
  updateHomepage: (data) => authAxios.put('/api/admin/content/homepage', data),
  getAbout: () => authAxios.get('/api/admin/content/about'),
  updateAbout: (data) => authAxios.put('/api/admin/content/about', data),
  getContact: () => authAxios.get('/api/admin/content/contact'),
  updateContact: (data) => authAxios.put('/api/admin/content/contact', data),
  getGaming: () => authAxios.get('/api/admin/content/gaming'),
  updateGaming: (data) => authAxios.put('/api/admin/content/gaming', data),
  getOffice: () => authAxios.get('/api/admin/content/office'),
  updateOffice: (data) => authAxios.put('/api/admin/content/office', data),
  getSupport: () => authAxios.get('/api/admin/content/support'),
  updateSupport: (data) => authAxios.put('/api/admin/content/support', data),
  getHeaderFooter: () => authAxios.get('/api/admin/content/header-footer'),
  updateHeaderFooter: (data) => authAxios.put('/api/admin/content/header-footer', data)
};

// Product service
export const productService = {
  getAll: () => authAxios.get('/api/admin/products/'),
  getOne: (id) => authAxios.get(`/api/admin/products/${id}`),
  create: (data) => authAxios.post('/api/admin/products/', data),
  update: (id, data) => authAxios.put(`/api/admin/products/${id}`, data),
  delete: (id) => authAxios.delete(`/api/admin/products/${id}`),
  seed: (products) => authAxios.post('/api/admin/products/seed', products)
};

// Public API service (no auth)
export const publicService = {
  getProducts: (type) => axios.get(`${API_URL}/api/public/products${type ? `?type=${type}` : ''}`),
  getProduct: (id) => axios.get(`${API_URL}/api/public/products/${id}`),
  getContent: (type) => axios.get(`${API_URL}/api/public/content/${type}`)
};
